import React, { FC, memo, useCallback, useMemo } from 'react';
import { OverlayView } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import {
  CourierReturnStatusType,
  ICourier,
  useCouriersActions,
  useCouriersState,
} from '../../context/couriers';
import useStyles from './styles';
import VehicleTypeIcon from '../VehicleTypeIcon';
import { getTimeFromDate, parseGuestName} from '@src/shared/utils';
import { Typography } from '@material-ui/core';
import { IOrder, useOrdersState } from '../../context/orders';
import JetFontIcon, { JET_FONTICON_ALIASES } from '@src/shared/components/JetFontIcon';
import useBackIn from '../../hooks/use-back-in';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { JETFM_CRT_COUNTDOWN_FLAG } from '@src/shared/models';
const CourierMarker: FC<ICourier> = ({
  firstName,
  lastName,
  location,
  id,
  orderPool,
  backBy,
  returnBack,
  vehicleType,
  isGuest,
}) => {
  const isCRTCountdownActive = useFMFeatureFlag(JETFM_CRT_COUNTDOWN_FLAG);
  const { t } = useTranslation();
  const classes = useStyles();
  const typographyVariant = 'caption'
  const { setSelectedCourierId } = useCouriersActions();
  const {getDistanceDuration} = useBackIn()
  const {selectedCourierId} = useCouriersState();
  const offsetHandler = useCallback(
    (_, offsetHeight) => ({
      x: -13,
      y: 11 - offsetHeight,
    }),
    []
  );
  const { ordersById } = useOrdersState();

  const position = useMemo(() => {
    return location
      ? {
          lat: location.latitude,
          lng: location.longitude,
        }
      : null;
  }, [location]);

  const backInBy = useMemo(() => {
    return backBy
  },[backBy?.eta]);

  

  const inDeliveryOrderReference = useMemo(() => {
    if (orderPool && orderPool.nextOrderReference) {
      return orderPool.nextOrderReference;
    }
  }, [orderPool]);

  const retrieveOrderData = (reference : string | undefined): IOrder => {
   if(!orderPool) { return {} as any }
    const order = Object.entries(ordersById).filter(([, value]) => {
      console.log('VALUES',value)
      return value['reference'] === reference
    }).map((findings)=> findings[1])[0]
    return order || {} as any
  }

  const getVehicleType = useMemo(() => {
    if (vehicleType) {
      return vehicleType;
    }
  }, [vehicleType]);

  /* If the status is returning, no matter if order is assigned or not */
  const isReturningCourier = backInBy &&
              returnBack?.status === CourierReturnStatusType.Returning 
  
  const hasOrderInBag = 
  orderPool?.route.waypoints.filter(
    (orders) => orders.isDelivered === false
  ).length
  return (
    <>
      {position ? (
        <OverlayView
          position={position}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={offsetHandler}
        >
          <div
            className={classes.boxWrapper}
          >
            <div onClick={() => setSelectedCourierId(id)} className={`${classes.box} order-status-${retrieveOrderData(inDeliveryOrderReference)?.status} ${
            selectedCourierId === id ? 'courier-selected' : '' } ${ isReturningCourier  ? 'courier-backby' : ''}`}>
              <div className={classes.boxItem}>
                {inDeliveryOrderReference &&  retrieveOrderData(inDeliveryOrderReference)?.customer && !isReturningCourier && (                 
                  <>
                   <Typography align='center' variant={typographyVariant} className={`${classes.customerName} ${classes.justify_center} caption_bold`}>
                       <JetFontIcon iconname={JET_FONTICON_ALIASES.STOPWATCH} ></JetFontIcon>  {retrieveOrderData(inDeliveryOrderReference)?.customer.lastName}
                    </Typography>
                    <div className='separator'></div>                   
                      <Typography variant={typographyVariant} className={`${classes.justify_center} ${classes.customerName} caption_bold`}>
                      <VehicleTypeIcon iconType="BADGE" iconSize={12} vehicleType={vehicleType} /> 
                      {isGuest ? parseGuestName(firstName) || lastName : firstName}
                    </Typography>                  
                  </>
                ) } 
                {!inDeliveryOrderReference && !isReturningCourier &&  (
                  /* We can use it for later to Backto Rest logic */
                  <>
                   <Typography variant={typographyVariant} className={`${classes.justify_center} caption_bold`}>
                  <Typography variant={typographyVariant} className='caption'> {t('courier.delivering_none')}</Typography>
                   </Typography> 
                   <div className='separator no-order'></div>         
                   <Typography variant={typographyVariant} className={`${classes.justify_center} ${classes.customerName} caption_bold`}>
                     <JetFontIcon iconname={JET_FONTICON_ALIASES.BIKE_SMALL} ></JetFontIcon> {isGuest ? parseGuestName(firstName) || lastName : firstName}
                   </Typography>  
                 </>
                )}
              </div>
              {/* TODO:Create a action in context side for filtering delivered orders */}
              {isReturningCourier && 
                (<div className={classes.boxItem}>
                  <Typography variant={typographyVariant} className={`${classes.justify_center} caption_bold`}>
                    {isCRTCountdownActive ? getDistanceDuration(backInBy) : <>{t('courier.backBy')} { getTimeFromDate(backBy?.eta)}</>}
                  </Typography>
                  <div className='separator'></div> 
                  <Typography variant={typographyVariant} className={`${classes.justify_center} ${classes.customerName} caption_bold`}>
                  {isGuest ? <JetFontIcon iconname={JET_FONTICON_ALIASES.BIKE_SMALL} ></JetFontIcon> :  <VehicleTypeIcon
                    iconType="BADGE"
                    iconSize={12}
                    vehicleType={vehicleType} /> }
                 
                      {isGuest ? parseGuestName(firstName) || lastName : firstName}
                   </Typography>  
                </div>
              )}
            </div>
            <VehicleTypeIcon orderStatus={retrieveOrderData(inDeliveryOrderReference)?.status} vehicleType={getVehicleType} />
          </div>
        </OverlayView>
      ) : null}
    </>
  );
};

export default memo(CourierMarker);
